import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

/**
 * Loading Interceptor - Shows spinner for API calls
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    private activeRequests = 0;

    constructor(private spinner: NgxSpinnerService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.activeRequests++;

        if (this.activeRequests === 1) {
            this.spinner.show();
        }

        return next.handle(request).pipe(
            finalize(() => {
                this.activeRequests--;
                if (this.activeRequests === 0) {
                    this.spinner.hide();
                }
            })
        );
    }
}
